<template>
  <vs-popup class="add-new-incoterms" id="popup" :title="`Buildings - ${details.Code}`" @close="open = false"
    :active.sync="open" :buttons-hidden="true">
    <vx-card no-shadow>
      <div class="flex mb-4">
        <vs-button v-can="'create-building'" @click="onClickCreate" class="mr-4" color="primary"
          type="filled">New</vs-button>
      </div>
      <vs-table :data="building_list">

        <template slot="thead">
          <vs-th width="20%">Code</vs-th>
          <vs-th width="20%">Name</vs-th>
          <vs-th width="10%"></vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">

            <vs-td :data="data[indextr].Code">
              {{ data[indextr].Code }}
            </vs-td>

            <vs-td :data="data[indextr].Name">
              {{ data[indextr].Name }}
            </vs-td>

            <vs-td>
              <div class="flex">
                <vx-tooltip text="Open Building" position="top">
                  <vs-button size="small" @click="onClickOpenBuilding(data[indextr]._id)" icon-pack="feather" icon="icon-eye"
                    class="ml-1"></vs-button>
                </vx-tooltip>
                <vx-tooltip text="Attachments" position="top">
                  <vs-button size="small" @click="onClickOpenAttachments(data[indextr])" icon-pack="feather" icon="icon-file"
                    class="ml-1"></vs-button>
                </vx-tooltip>
                <vx-tooltip text="Remove" position="top">
                  <vs-button size="small" @click="onClickBuildingRemove(data[indextr]._id)" icon-pack="feather" icon="icon-trash-2"
                    color="danger" class="ml-1"></vs-button>
                </vx-tooltip>
              </div>
            </vs-td>
          </vs-tr>
        </template>

      </vs-table>
    </vx-card>
    <CreateObjectPopUp ref="createObjectPopUp" @refreshData="refreshData"/>
    <ObjectAttachmentPopUp ref="objectAttachmentPopUp" @refreshData="refreshData"/>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const TenantRepository = RepositoryFactory.get('tenant')
import CreateObjectPopUp from "@/components/popups/general/CreateObjectPopUp.vue"
const ObjectRepository = RepositoryFactory.get('object');

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import ObjectAttachmentPopUp from "@/components/popups/attachments/ObjectAttachmentPopUp.vue"

function initialState() {
  return {
    open: false,
    details: {
      Code: ''
    },
    object_name: '',
    building_list: []
  }
}

export default {
  name: 'AssessmentBuildingsPopUp',
  data() {
    return initialState()
  },
  methods: {
    async refreshData(data) {
      console.log(data.data.data._id);
      if(data.data.data._id) {
        await this.AddActionToAssessment(data.data.data._id);
        await this.fetchBuildings()
      }
      
    },
    async openPopup(details, object_name) {
      try {
        await Object.assign(this.$data, initialState());
        Object.assign(this.details, details);
        this.object_name = object_name;
        await this.fetchBuildings();
        this.open = true;
      } catch (error) {
        console.log(error);
      }
    },
    async onClickCreate() {
      await this.$refs.createObjectPopUp.openPopup('building', 'create', this.details ? { Company: this.details.Company } : {})
    },
    async AddActionToAssessment(id) {
      try {
        let payload = {}
        if(this.object_name === 'propertyriskassessment') {
          payload = { PropertyRiskAssessment: this.details._id }
        } else if(this.object_name === 'copeassessment') {
          payload = { CopeAssessment: this.details._id }
        }
        await ObjectRepository.updateObject('building', id, payload)
      } catch (error) {
        
      }
    },
    async fetchBuildings() {
      this.$vs.loading();
      try {
        const { data } = (await TenantRepository.getAssessmentBuildings(this.object_name, this.details._id)).data;
        this.building_list = data;
      } catch (e) {
        console.log(e);
      }
      this.$vs.loading.close();
    },
    async onClickOpenAttachments(data) {
      await this.$refs.objectAttachmentPopUp.openPopup(data, 'building')
    },
    async onClickOpenBuilding(id) {
      let route = this.$router.resolve({ path: `/pages/buildings?open=${id}` });
      window.open(route.href, '_blank');
    },
    async onClickBuildingRemove(id) {
      try {
        await TenantRepository.removeBuildingFromAssessment(id)
        await this.fetchBuildings()
      } catch (error) {
        
      }
    }
  },
  components: {
    flatPickr,
    'v-select': vSelect,
    CreateObjectPopUp,
    ObjectAttachmentPopUp
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
.add-new-incoterms>>>.vs-popup {
  /*min-height: 50% !important;*/
  min-width: 70% !important;
}
</style>
